export default __webpack_public_path__ + "static/media/line-return.90b707fd.mp4";